export interface IUpdateUnshadedPercentRequest {
  epcCalculationId: number;
  unshadedPercent: number;
  igsCustomerNumber: string;
}

export class UpdateUnshadedPercentRequest implements IUpdateUnshadedPercentRequest {
  epcCalculationId: number;
  unshadedPercent: number;
  igsCustomerNumber: string;

  constructor(igsCustomerNumber: string, unshadedPercent: number, epcCalcId: number) {
    this.igsCustomerNumber = igsCustomerNumber;
    this.unshadedPercent = unshadedPercent;
    this.epcCalculationId = epcCalcId;
  }
}
